export default __webpack_public_path__ + "static/media/consort_diagram004Bext.0e111fa1.png";